import React from 'react';

interface ContextMenuProps<T> {
    x: number;
    y: number;
    data: T;
    onOpenOrderForm: (data: T, side: 'BUY' | 'SELL') => void;
    onClose: () => void;
    getLabel?: (data: T) => string;
}

function ContextMenu<T extends { security_id?: string }>({ 
    x, 
    y, 
    data, 
    onOpenOrderForm, 
    onClose,
    getLabel
}: ContextMenuProps<T>) {
    const label = getLabel ? getLabel(data) : data.security_id || '';

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999,
                }}
                onClick={onClose}
                onContextMenu={(e) => e.preventDefault()}
            />
            <div
                style={{
                    position: 'fixed',
                    top: y,
                    left: x,
                    backgroundColor: '#2d2d2d',
                    border: '1px solid #444',
                    borderRadius: '4px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                    zIndex: 1000,
                    minWidth: '150px',
                }}
            >
                <button
                    onClick={() => {
                        onOpenOrderForm(data, 'BUY');
                        onClose();
                    }}
                    style={{
                        width: '100%',
                        padding: '10px 16px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#22c55e',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        borderBottom: '1px solid #444',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3a3a3a'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    Buy {label}
                </button>
                <button
                    onClick={() => {
                        onOpenOrderForm(data, 'SELL');
                        onClose();
                    }}
                    style={{
                        width: '100%',
                        padding: '10px 16px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#ef4444',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        fontWeight: 'bold',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3a3a3a'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                    Sell {label}
                </button>
            </div>
        </>
    );
}

export default ContextMenu;

